module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-00.1@2x.41e25a65.jpg";